module.exports = __webpack_public_path__ + "static/media/ic_theme_generic.f438df4c.svg";